import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { AppContainer } from './AppContainer';
import { initializeAppInsightsFromConfig } from '../../timetrack-pro/src/lib/app-insights';

// Initialize Application Insights from runtime config (non-blocking)
initializeAppInsightsFromConfig();

// Clear persisted theme to ensure light mode on every application load
localStorage.removeItem('theme');

localStorage.setItem('timetrack-data-source', 'live');
localStorage.setItem('timetrack-data-source-locked', 'true');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container missing in index.html');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <AppContainer />
  </StrictMode>,
);
